webpackJsonp([0],{

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChooseCompany_vue__ = __webpack_require__(603);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d55e14_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChooseCompany_vue__ = __webpack_require__(621);
function injectStyle (ssrContext) {
  __webpack_require__(619)
}
var normalizeComponent = __webpack_require__(101)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04d55e14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChooseCompany_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d55e14_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChooseCompany_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ChooseCompany',
  methods: {
    loginFor: function loginFor(teamId) {
      var _this = this;

      this.$post('api/teams' + this.$route.fullPath + '&team=' + teamId).then(function (response) {
        if (response.ok) {
          response.json().then(function (result) {
            if (result.team) {
              _this.$store.commit('SET_TEAM', result);
              _this.$store.commit('SET_LOGIN', true);
            }
          });
        } else {
          response.json().then(function (result) {
            _this.$store.commit('SET_LOGIN', false);
            _this.$store.state.signinError = result.error;
          });
        }
      });
    },
    company_logo: function company_logo(_company_logo) {
      if (_company_logo) {
        return 'https://convertlabs.io/' + _company_logo.replace('public', 'storage');
      }
    }
  }
});

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(620);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(594)("6678775c", content, true, {});

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(593)(true);
// imports


// module
exports.push([module.i, ".teams-login[data-v-04d55e14]{width:100vw}.teams-login .container[data-v-04d55e14]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.logo img[data-v-04d55e14]{max-width:400px}.company[data-v-04d55e14]{max-width:700px;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:16px;margin-bottom:16px}", "", {"version":3,"sources":["/home/teamsconvertlabs/public_html/src/views/auth/ChooseCompany.vue"],"names":[],"mappings":"AACA,8BACI,WAAa,CAChB,AACD,yCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC/B,AACD,2BACI,eAAiB,CACpB,AACD,0BACI,gBAAiB,AACjB,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAU,AACV,kBAAoB,CACvB","file":"ChooseCompany.vue","sourcesContent":["\n.teams-login[data-v-04d55e14] {\n    width: 100vw;\n}\n.teams-login .container[data-v-04d55e14] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.logo img[data-v-04d55e14] {\n    max-width: 400px;\n}\n.company[data-v-04d55e14] {\n    max-width: 700px;\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.selectCompany)?_c('div',{staticClass:"teams-login"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_vm._v("Hello "),_c('span',{staticClass:"fw-500"},[_vm._v(_vm._s(_vm.$route.query.team_email))]),_vm._v(", please select a company below")]),_vm._v(" "),_vm._l((_vm.$store.state.selectCompany),function(team,index){return _c('div',{key:index,staticClass:"card company",on:{"click":function($event){return _vm.loginFor(team.id)}}},[_c('div',{staticClass:"d-flex align-items-center"},[_c('img',{attrs:{"height":"50","width":"50","src":_vm.company_logo(team.company.company_logo)}}),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column ml-3"},[_c('span',{staticClass:"capitalize text-truncate team-title fs-14 fw-500"},[_vm._v(_vm._s(team.title))]),_vm._v(" "),_c('span',{staticClass:"capitalize text-truncate company-name fs-14 secondary-text"},[_vm._v(_vm._s(team.company.company_name))])])]),_vm._v(" "),_c('el-button',{staticClass:"primary-button",attrs:{"type":"primary"},on:{"click":function($event){return _vm.loginFor(team.id)}}},[_vm._v("Log In")])],1)})],2)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo pt-4 pb-5"},[_c('img',{attrs:{"src":"/static/img/ConvertLabs.svg","alt":"Convertlabs Logo"}}),_vm._v(" "),_c('div',{staticClass:"fw-500 text-center"},[_vm._v("Service Providers")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.4964640895aa48966e69.js